var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"id":"UserAccount"}},[(_vm.user.loaded != true)?_c('div',{staticClass:"center"},[_c('LoadingSpinner')],1):_vm._e(),_c('div',[_c('UserPhoto'),_c('UserDetails')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }